import { Chip } from "@ui/Atoms/Chip/Chip";
import { Link } from "@ui/Atoms/Link/Link";

export type CityChip = {
	slug: string;
	label: string;
	count: number;
	href?: string;
};

type Props = {
	cities: CityChip[];
	layout?: "wrap" | "scroll";
	onSelect?: (slug: string) => void;
};

export function CityChips({ cities, layout = "wrap", onSelect }: Props) {
	const container =
		layout === "scroll"
			? "flex gap-2 overflow-x-auto scrollbar-hide -mx-5 px-5 pb-0.5"
			: "flex flex-wrap gap-2";

	return (
		<div className={container}>
			{cities.map((city) =>
				city.href ? (
					<Link key={city.slug} href={city.href} className="shrink-0">
						<Chip as="span" label={city.label} count={city.count} />
					</Link>
				) : (
					<Chip
						key={city.slug}
						label={city.label}
						count={city.count}
						style={{ flexShrink: 0 }}
						onClick={() => onSelect?.(city.slug)}
					/>
				),
			)}
		</div>
	);
}
